export const USER_ROW_LIMIT = 10;
export const WIDGETS_API_VERSION = "1";
export const WIDGETS_CLASS_NAMESPACE = "woswidgets";
//# sourceMappingURL=constants.js.map